import { makeStyles } from '@mui/styles';

// colors
import { colors } from '../../../colors';

export const useStyles = makeStyles({
  root: {
    height: 8,
    borderRadius: 99,
    width: '100%',
    backgroundColor: colors.neutral100,
    '& .MuiLinearProgress-bar': {
      borderRadius: 99,
      backgroundColor: colors.secondary500,
    },
  },
});
